module.exports = __webpack_public_path__ + "img/c04_buildingtechshieldwall_Normal_ua.435c19df.webp";